import { State } from '../state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnModelerState } from './bpmn-modeler-state.selector';

const getNodesWithNotes = (state: State): Set<string> => state.nodesWithNotes;

export const selectNodesWithNotes: MemoizedSelector<object, Set<string>> =
    createSelector(selectBpmnModelerState, getNodesWithNotes);

const getActiveNodeNotesPanel = (state: State): string => state.activeNodeNotesPanel;

export const selectActiveNodeNotesPanel: MemoizedSelector<object, string> =
    createSelector(selectBpmnModelerState, getActiveNodeNotesPanel);
